import {makePostDeclineWellBornProgram} from 'main/factories/usecases/private/well-born/post-decline-program';

export async function postDeclineWellBornProgram() {
	const declineWellBornProgram = makePostDeclineWellBornProgram();
	return declineWellBornProgram.decline();
}
